/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import SettingSidebar from "../../components/settingsidebar";
import Appearance from "./features/aapearance";

const ApiKey = () => {
  return (
    <>
      <Layout>
        <section className="setting_page d_flx align_top">
          <SettingSidebar />
          <Appearance />
        </section>
      </Layout>
    </>
  );
};
export default ApiKey;
